// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__L893v","btn--primary":"button_btn--primary__nGU2D","btn--secondary":"button_btn--secondary__7g1VH"};